module.exports = __webpack_public_path__ + "static/2-small-1163d44243e8ed83e689d76f8b304851.jpg";